import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/wallet with credit card.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import TitleImg from "../assets/images/DeathModuleNew/Ellipse 105.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import List from "./styledComponents/Table/List";
import { Modal } from "antd";
import Table from "./styledComponents/Table/Table";
import CalanderFull from "./styledComponents/Calander/calanderfull";
// import events from "../components/form/components/events";
import AddModal from "./styledComponents/Modal/AddModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
import Loader from "../components/styled-components/loader/loader";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import ViewModal from "./styledComponents/Modal/ViewModal";
import swal from "sweetalert";
import axios from "axios";
import moment from "moment";

export const BillsToPay = (props) => {
  const fields = [
    {
      title: "Amount",
      type: "currency",
      index: "Amount",
    },
    {
      title: "Payee Name",
      type: "input",
      index: "PayeeName",
    },
    {
      title: "Category",
      type: "select",
      options: [
        "Auto & Transport",
        "Bills & Utilities",
        "Business Services",
        "Education",
        "Entertainment",
        "Fees & Charges",
        "Food & Dining",
        "Gifts & Donations",
        "Health & Fitness",
        "Income",
        "Investments",
        "Kids",
        "Miscellaneous",
        "Personal Care",
        "Shopping",
        "Taxes",
        "Travel",
        "Others",
      ],
      index: "Category",
    },
    {
      title: "Frequency",
      type: "select",
      options: [
        "Weekly",
        "Biweekly",
        "Semimonthly",
        "Monthly",
        "Quarterly",
        "Semi-annually",
        "Annually",
      ],
      index: "Frequency",
    },
    {
      title: "Start Date",
      type: "date",
      index: "StartDate",
    },
    {
      title: "End Date",
      type: "date",
      index: "DueDate",
    },
    {
      title: "Receipt",
      type: "file",
      index: "Receipt",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "Notes",
    },
  ];

  const update_fields = [
    {
      title: "Amount",
      type: "currency",
      index: "amount",
    },
    {
      title: "Payee Name",
      type: "input",
      index: "payeeName",
    },
    {
      title: "Category",
      type: "select",
      options: [
        "Auto & Transport",
        "Bills & Utilities",
        "Business Services",
        "Education",
        "Entertainment",
        "Fees & Charges",
        "Food & Dining",
        "Gifts & Donations",
        "Health & Fitness",
        "Income",
        "Investments",
        "Kids",
        "Miscellaneous",
        "Personal Care",
        "Shopping",
        "Taxes",
        "Travel",
        "Others",
      ],
      index: "category",
    },
    {
      title: "Frequency",
      type: "select",
      options: [
        "Weekly",
        "Biweekly",
        "Semimonthly",
        "Monthly",
        "Quarterly",
        "Semi-annually",
        "Annually",
      ],
      index: "frequency",
    },
    {
      title: "Start Date",
      type: "date",
      index: "startDate",
    },
    {
      title: "End Date",
      type: "date",
      index: "dueDate",
    },
    {
      title: "Receipt",
      type: "file",
      index: "receiptUrl",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "note",
    },
  ];

  const cols = [
    {
      title: "Payee Name",
      dataIndex: "payeeName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },

    {
      title: "Category",
      dataIndex: "category",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Start Date",
      dataIndex: "startDate",
      render: (record) =>
        record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },
    {
      title: "End Date",
      dataIndex: "dueDate",
      render: (record) =>
        record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },
    {
      title: "File",
      dataIndex: "receiptUrl",
      render: (fileName, record) => {
        return record.receiptUrl ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a
              style={{ color: "#7d8fb3" }}
              href={record.receiptUrl}
              target="blank">
              {" "}
              {record.fileName}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Notes",
      dataIndex: "note",

      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            {" "}
            <div
              onClick={() => {
                setDropdown(!dropdown);
                getSelectedRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              {" "}
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedRow(record.id);
                          setDropdown(false);
                        }}>
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}>
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewModal(true);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const [billList, setBillList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [addData, setaddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [tooltipModal, setTooltipModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [weeklyEvents, setWeeklyEvents] = useState([]);

  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };
  useEffect(() => {
    console.log("calling api");
    getBills();
  }, []);
  const getBills = async () => {
    try {
      // this.props.handleLoader();
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchBills(ID);
      setLoading(false);
      setEvents([]);
      let obj = [];
      if (data && data.data) {
        setBillList(data.data);
        data.data.map((item, index) => {
          if (item.frequency === "Weekly") {
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.dueDate);
            const oneWeek = 7 * 24 * 60 * 60 * 1000; // One week in milliseconds
            const weeklyDates = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
              weeklyDates.push(new Date(currentDate));
              currentDate.setTime(currentDate.getTime() + oneWeek);
            }
            // Print the weekly dates
            for (const date of weeklyDates) {
              console.log("datessss", date.toUTCString());
              obj.push({
                id: item.id,
                title: item.payeeName,
                start: new Date(date),
                end: new Date(date),
                Amount: item.amount,
                desc: item.note,
              });
            }
          }
          if (item.frequency === "Biweekly") {
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.dueDate);
            const oneWeek = 14 * 24 * 60 * 60 * 1000; // One week in milliseconds
            const weeklyDates = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
              weeklyDates.push(new Date(currentDate));
              currentDate.setTime(currentDate.getTime() + oneWeek);
            }
            // Print the weekly dates
            for (const date of weeklyDates) {
              console.log("datessss", date.toUTCString());
              obj.push({
                id: item.id,
                title: item.payeeName,
                start: new Date(date),
                end: new Date(date),
                Amount: item.amount,
                desc: item.note,
              });
            }
          }
          if (item.frequency === "Semimonthly") {
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.dueDate);
            const oneWeek = 15 * 24 * 60 * 60 * 1000; // One week in milliseconds
            const weeklyDates = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
              weeklyDates.push(new Date(currentDate));
              currentDate.setTime(currentDate.getTime() + oneWeek);
            }
            // Print the weekly dates
            for (const date of weeklyDates) {
              console.log("datessss", date.toUTCString());
              obj.push({
                id: item.id,
                title: item.payeeName,
                start: new Date(date),
                end: new Date(date),
                Amount: item.amount,
                desc: item.note,
              });
            }
          }
          if (item.frequency === "Monthly") {
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.dueDate);
            const monthlyDates = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
              monthlyDates.push(new Date(currentDate));
              currentDate.setMonth(currentDate.getMonth() + 1);
            }
            // Print the monthly dates
            for (const date of monthlyDates) {
              console.log(date.toDateString());
              obj.push({
                id: item.id,
                title: item.payeeName,
                start: new Date(date),
                end: new Date(date),
                Amount: item.amount,
                desc: item.note,
              });
            }
          }
          if (item.frequency === "Quarterly") {
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.dueDate);
            const monthlyDates = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
              monthlyDates.push(new Date(currentDate));
              currentDate.setMonth(currentDate.getMonth() + 3);
            }
            // Print the monthly dates
            for (const date of monthlyDates) {
              console.log(date.toDateString());
              obj.push({
                id: item.id,
                title: item.payeeName,
                start: new Date(date),
                end: new Date(date),
                Amount: item.amount,
                desc: item.note,
              });
            }
          }
          if (item.frequency === "Semi-annually") {
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.dueDate);
            const monthlyDates = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
              monthlyDates.push(new Date(currentDate));
              currentDate.setMonth(currentDate.getMonth() + 6);
            }
            // Print the monthly dates
            for (const date of monthlyDates) {
              console.log(date.toDateString());
              obj.push({
                id: item.id,
                title: item.payeeName,
                start: new Date(date),
                end: new Date(date),
                Amount: item.amount,
                desc: item.note,
              });
            }
          }
          if (item.frequency === "Annually") {
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.dueDate);
            const oneYear = 365 * 24 * 60 * 60 * 1000; // One year in milliseconds
            const annualDates = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
              annualDates.push(new Date(currentDate));
              currentDate.setTime(currentDate.getTime() + oneYear);
              currentDate.setFullYear(currentDate.getFullYear() + 1);
            }
            // Print the annual dates
            for (const date of annualDates) {
              console.log(date.toDateString());
              obj.push({
                id: item.id,
                title: item.payeeName,
                start: new Date(date),
                end: new Date(date),
                Amount: item.amount,
                desc: item.note,
              });
            }

            // Print the monthly dates
          }
          console.log("arrayof Ibjects", obj);
        });
        // console.log("weeklyEvents", weeklyEvents);
        setEvents((prevState) => [...prevState, ...obj]);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  console.log("weeklyEvents", events);
  const createBills = async () => {
    // check if already formData contains some data then initialize it with empty

    var arr = [addData];
    try {
      let data = arr;
      setLoading(true);

      if (Array.isArray(data) && data.length > 0) {
        const allPromises = data.map(async (item) => {
          if (item.Receipt) {
            const formData = new FormData();
            formData.append("file", item.Receipt);
            console.log("item.file", item.Receipt);
            const name = item.Receipt.name;
            const lastDot = name.lastIndexOf(".");
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            const resdata = await MODULE_API.uploadFile({
              fileExt: ext,
              contentType: item.Receipt.type,
            });
            const resupload = await axios.put(resdata.uploadUrl, item.Receipt, {
              headers: { "Content-type": item.Receipt.type },
            });
            const res = resdata.uploadUrl.split("?")[0];
            console.log(res);
            delete item.Receipt;
            return { ...item, fileUrl: res, fileName: name };
          }
          return item;
        });
        let res = await Promise.all(allPromises);
        let api_res = await DEATH_API.addBills({
          billsToPayForm: res.map((item) => {
            console.log("item in bill to pay", item);
            return {
              amount: +item.Amount,
              payeeName: item["Payee Name"],
              frequency: item.Frequency,
              category: item.Category,
              dueDate: item["End Date"],
              startDate: item["Start Date"],
              fileName: item.fileName,
              receiptUrl: item.fileUrl || null,
              note: item.Notes,
            };
          }),
        });
        setLoading(false);
        getBills();

        return api_res;
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      throw new Error(error);
    }
  };
  const updateBills = async () => {
    console.log("update bills", updateObject);
    try {
      setLoading(true);
      let uploaded = {};
      if (updateObject.Receipt) {
        const formData = new FormData();
        formData.append("file", updateObject.Receipt);

        const name = updateObject.Receipt.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: updateObject.Receipt.type,
        });
        const resupload = await axios.put(
          resdata.uploadUrl,
          updateObject.Receipt,
          { headers: { "Content-type": updateObject.Receipt.type } }
        );
        const res = resdata.uploadUrl.split("?")[0];
        console.log("resss file url", res);
        uploaded.file_url = res;
        uploaded.fileName = name;
      }

      let obj = {
        ...updateObject,
        amount: +updateObject.Amount || +updateObject.amount || null,
        payeeName: updateObject.payeeName,
        category: updateObject.category,
        dueDate: updateObject["End Date"],
        fileName: uploaded
          ? uploaded.fileName
          : updateObject.fileName
          ? updateObject.fileName
          : null,
        DueDate:
          updateObject["End Date"] &&
          moment(updateObject["End Date"]).format("LL"),
        startDate:
          updateObject["Start Date"] &&
          moment(updateObject["Start Date"]).format("LL"),
        receiptUrl: uploaded
          ? uploaded.file_url
          : updateObject.receiptUrl
          ? updateObject.receiptUrl
          : null,
        note: updateObject.note,
        id: updateObject.id,
      };
      console.log("update object 1", obj);

      delete obj.Receipt;
      console.log("update object 2", obj);
      await DEATH_API.updateBills(obj.id, obj);
      setLoading(false);

      getBills();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const deleteSelectedRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        // that.props.handleLoader()
        try {
          setLoading(true);
          await DEATH_API.deleteBills(idx);
          setLoading(false);
          const updatedRows = billList.filter((row) => {
            return row.id != idx;
          });
          setBillList(updatedRows);
          getBills();
        } catch (error) {
          console.log("error deleting Bills to pay");
          console.log(error);
        }
        setTimeout(async () => {
          setLoading(true);
          swal("Deleted!", "Your file has been deleted.", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleCurrencychange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;
    const inputString = e.target.value;
    const convertedNumber = parseFloat(inputString.replace(/,/g, ""));

    setaddData({
      ...addData,
      [name]: convertedNumber,
    });
  };
  const handleUpdateCurrencychange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;
    const inputString = e.target.value;
    const convertedNumber = parseFloat(inputString.replace(/,/g, ""));
    setUpdateObject({
      ...updateObject,
      [name]: convertedNumber,
    });
  };
  const handleSelectChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateSelectChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const SubmitUpdate = () => {
    console.log("updated object submit", updateObject);
    updateBills();
    handelCloseUpdateModal();
  };
  const submitData = () => {
    console.log("submit data", addData);
    createBills();
    handelCloseModal();
  };
  const handelCloseModal = () => {
    setShowModal(false);
  };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const getSelectedRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = billList.filter((row, index) => {
      return row.id == idx;
    });

    // get first and only element from list and store it in update object
    console.log("selectedRow", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };

  return (
    <div>
      {" "}
      {showModal && (
        <AddModal
          show={showModal}
          close={handelCloseModal}
          fields={fields}
          modalTitle="Add New Bill"
          handlechange={handlechange}
          handleCurrencychange={handleCurrencychange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
          handleSelectChange={handleSelectChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={update_fields}
          modalTitle="Update Bill"
          handlechange={handleUpdatechange}
          handleUpdateCurrencychange={handleUpdateCurrencychange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          handleUpdateSelectChange={handleUpdateSelectChange}
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={update_fields}
          modalTitle="View Bill"
          obj={updateObject}
        />
      )}
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Upcoming Bills</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              Often, one of the most pressing concerns for friends and loved
              ones is how to pay bills for the deceased and which ones are
              coming up. Added features might also denote which bills are paid
              auto-pay from a bank account or credit card, along with other
              details that may prove to be helpful.
            </Style.ModalDetails>
          </div>
          <div
            style={{
              display: "flex",
              height: "fit-content",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {tooltipModal && (
              <video style={{ width: "25rem" }} controls>
                <source
                  src={
                    "https://assets-planet.s3.amazonaws.com/media/ad34f017-3399-4b17-8084-32efc0e1c1fd.mp4"
                  }
                  type="video/mp4"
                />
              </video>
            )}
          </div>
        </div>
      </Modal>
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        Bills to Pay{" "}
        <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon>
      </Style.MainHeading>
      <CalanderFull props={events} />
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Bills</Style.Title>
          {props.role !== "protrustee" && (
            <div>
              <Style.Button
                onClick={() => {
                  setShowModal(true);
                }}>
                +
              </Style.Button>
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={cols} rows={billList}></List>
      </Style.HealthCard>
      <Loader isLoading={loading} />
    </div>
  );
};
